import { useEffect, useCallback, useRef, cloneElement } from 'react';

import { useQueryClient } from '@gogame/query';
import { useChildComponentRouteV2, useScreenDispatch } from '@gogame/screens';
import { useScreenState } from '@gogame/screens';

import { grids } from '../../data/queryKeyFactory';
import IODetails from './IODetails';

const RESET_IO_STATUS_BEFORE_DOCU_SIGNING =
  'RESET_IO_STATUS_BEFORE_DOCU_SIGNING';

export const IODetailsRouteElement = () => {
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();
  const ioStatusBeforeDocuSigning = screenState.ioStatusBeforeDocuSigning;
  const queryClient = useQueryClient();
  const ioRef = useRef();

  const resetIOStatus = useCallback(
    () =>
      dispatch({
        type: RESET_IO_STATUS_BEFORE_DOCU_SIGNING,
      }),
    []
  );

  const handleClose = () => {
    const io = ioRef.current;
    if (
      ioStatusBeforeDocuSigning &&
      io?.status?.id === ioStatusBeforeDocuSigning
    ) {
      queryClient.invalidateQueries(grids);
    }
  };

  useEffect(() => {
    if (ioStatusBeforeDocuSigning) {
      resetIOStatus();
    }
  }, [ioStatusBeforeDocuSigning]);

  const childComponent = useChildComponentRouteV2(IODetails, {
    onClose: handleClose,
    onLoadIo: (io) => {
      ioRef.current = io;
    },
  });

  return childComponent
    ? cloneElement(childComponent, {
        ioStatusBeforeDocuSigning: screenState.ioStatusBeforeDocuSigning,
      })
    : childComponent;
};
